export default "__VITE_ASSET__r6SoS1TF__"